import { FC } from 'react';
import { DocumentUpload } from './DocumentUpload';

interface UploadDocumentTabProps {
  hasLinkedInToken: boolean;
  onDocumentUploaded?: (imageUrl: string) => void;
  onPostToLinkedIn?: (documentId: string) => void;
}

/**
 * Testing Tab Component
 * Contains testing tools for image upload and LinkedIn posting
 * Only visible to external users
 */
export const UploadDocumentTab: FC<UploadDocumentTabProps> = ({
  hasLinkedInToken,
  onDocumentUploaded,
  onPostToLinkedIn,
}) => {
  return (
    <div className="space-y-6">
      <DocumentUpload
        hasLinkedInToken={hasLinkedInToken}
        onDocumentUploaded={onDocumentUploaded}
        onPostToLinkedIn={onPostToLinkedIn}
      />
    </div>
  );
};


